import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";

export const shouldShowAhsBookingLinkCard = ({
  ahsSubServiceId,
  isAhsRepeatUser,
  isPageReadonly,
  rescheduleFlag,
}: ISlotsState): boolean => Boolean(ahsSubServiceId) && Boolean(isAhsRepeatUser) && !isPageReadonly && !rescheduleFlag;
